import axios from "axios";
import {store} from "../store";
import { getGameOriginDomain } from "../utilites";

const baseURL = `${process.env.REACT_APP_BASE_URL}.${getGameOriginDomain()}` || "https://games-api.fostcraft.com/"

export const axiosInstance = axios.create({
    baseURL,
})

axiosInstance.interceptors.request.use((config) => {
    const accessToken = store.accessToken;

    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
    }
    return config
})
